import dayjs from 'dayjs/esm';
import { ICbicContentMst } from '../cbic-content-mst/cbic-content-mst.model';
import { ICbicDocMst } from '../cbic-doc-mst/cbic-doc-mst.model';

export interface ICbicInternalDocMapping {
  id?: number;
  isActive?: string | null;
  orderId?: number | null;
  createdDt?: dayjs.Dayjs | null;
  updatedDt?: dayjs.Dayjs | null;
  createdBy?: number | null;
  updatedBy?: number | null;
  versionNo?: number | null;
  isPublished?: string | null;
  publishDt?: dayjs.Dayjs | null;
  isArchived?: string | null;
  archivedDt?: dayjs.Dayjs | null;
  cbicContentMstDTO?: ICbicContentMst | null |undefined;
  cbicDocMstDTO?: ICbicDocMst | null |undefined;
}

export class CbicInternalDocMapping implements ICbicInternalDocMapping {
  constructor(
    public id?: number,
    public isActive?: string | null,
    public orderId?: number | null,
    public createdDt?: dayjs.Dayjs | null,
    public updatedDt?: dayjs.Dayjs | null,
    public createdBy?: number | null,
    public updatedBy?: number | null,
    public versionNo?: number | null,
    public isPublished?: string | null,
    public publishDt?: dayjs.Dayjs | null,
    public isArchived?: string | null,
    public archivedDt?: dayjs.Dayjs | null,
    public cbicContentMstDTO?: ICbicContentMst | null,
    public cbicDocMstDTO?: ICbicDocMst | null
  ) {}
}

export function getCbicInternalDocMappingIdentifier(cbicInternalDocMapping: ICbicInternalDocMapping): number | undefined {
  return cbicInternalDocMapping.id;
}
